import { LitElement, html, css } from 'lit-element'

//函數
import { generateImg,generateImgReq, img2img } from './js/generate-img-api';
import { uploadFile1,uploadFile2} from './firebase-uploadfile';
//

export default class GenerateImgClass extends LitElement {
    constructor () {
        super()
        window.fetch('config.json').then(res => res.json()).then(config => {
          this.defaultIndex = config.defaultIndex
          this.defaultBackend = config.defaultBackend
          this.urlColumn = config.urlColumn || 'url'
          this.init()
        })
      }
    
      init () {
        this.yourText='';
        this.resultText='';
        this.uploadFileSrc='';

        this.shadowRoot.getElementById('text-type').style='display:none;'
          
// //
this.shadowRoot.getElementById('yourSeed').value=Math.floor(Math.random() * (4555 - 1024 + 1)) + 1024;

      }
      static get properties () {
        return {
          // service: { type: Object }
          yourText : {type: String},
          resultText : {type: String},
          uploadFileSrc : {type:String}
        }
      }
      
      firstUpdated () {
        
      }

      async generateResult(){
        
        var yourSubscribeStateEle=document.getElementById('yourSubscribeState');
        if(yourSubscribeStateEle.value=='0'){
          alert('Please go to the home page to subscribe')
          return;
        }
        if (typeof promptDetailDialog.showModal === "function") {
          
          document.getElementById("promptP1").innerHTML = 'please wait...';
          document.getElementById("promptP2").innerHTML = ''
          document.getElementById("confirmBtn").style="display:block;"
          document.getElementById("promptDetailDialog").showModal();
        }
        //todo text-to-img
        if(this.shadowRoot.getElementById('textType1').checked){
          this.resultText=await generateImg(this.yourText)
          const resultTextElement = this.shadowRoot.getElementById('resultText')
          resultTextElement.src=this.resultText;
          return;
        }
        // if(this.uploadFileSrc==''||this.uploadFileSrc==undefined){
        //   alert('Please upload picture first')
        //   return;
        // }
        
        //todo img-to-img
        var yourPrompt=this.shadowRoot.getElementById('yourText').value
        var initFileUrl=document.getElementById('initFileUrl').value
        // var initFileUrl=this.uploadFileSrc;
        var maskFileUrl=''
        if(yourPrompt==''){
          alert('please input your prompt')
          return;
        }
        if(this.shadowRoot.getElementById('textType2').checked&&initFileUrl==''){
          alert('wait a second,please img upload')
          return;
        }
        var yourSeedText=this.shadowRoot.getElementById('yourSeed').value;
        if(yourSeedText==''||yourSeedText==undefined||yourSeedText==null){
            yourSeedText=1024;
        }
        var yourNumOutPutText=this.shadowRoot.getElementById('yourNumOutPut').value;
        if(yourNumOutPutText==''||yourNumOutPutText==undefined||yourNumOutPutText==null){
           yourNumOutPutText=1;
        }
        if(yourNumOutPutText>4){
           window.alert('max num is 4')
            return;
        }
        if(yourNumOutPutText>4){
          window.alert('max num is 4')
           return;
       }
        //todo 生成藝術
        
        var resultArr=await generateImgReq(yourPrompt,yourSeedText,yourNumOutPutText,initFileUrl,maskFileUrl);
        if(resultArr=='code:1024,msg:sorry,something wrong 1'){
          alert(resultArr)
          return;
        }
        if(resultArr=='code:1024,msg:sorry,something wrong 2'){
          alert(resultArr)
          return;
        }
        //
        if(resultArr!=undefined){
          var resultHtml=''
          for(var i=0;i<resultArr.length;i++){
            resultHtml=resultHtml+'<img id="resultText"'+i+' src='+resultArr[i]+'><br/>';

          }
          this.shadowRoot.getElementById('resultImgs').innerHTML=resultHtml;
        }

        // await img2img()

      }

      async uploadImage(file){
        var uploadUrl=await uploadFile1(file)
        // this.shadowRoot.getElementById('initFileUrl').value=uploadUrl
      }

      async uploadImage2(file){
        // var uploadUrl=await uploadFile2(file)
       
      }


      // function uploadbtnActive(){
        
        
      // }
      
//       this.shadowRoot.getElementById("yourInitImage").addEventListener('change', function(){
    
// });

      clickRadio(radioType){
        if(radioType.value=='1'){
          this.shadowRoot.getElementById('text-type').style='display:none;'
          //
          document.getElementById('initFileUrl').value='';

        }else if(radioType.value=='2'){
          this.shadowRoot.getElementById('text-type').style='display:block;'
        }else{

        }

        // var textType = this.shadowRoot.getElementById('textType');
        // var prev = null;
        // for (var i = 0; i < textType.length; i++) {
        // textType[i].addEventListener('change', e=> {
        //       //上一次選項
        //       (prev) ? console.log(prev.value): null;
        //       if (e !== prev) {
        //           prev = e;
        //       }
        //       //下一次選項
        //       console.log(e.value)
        //       //
        //       if(this.value=='1'){
        //         this.shadowRoot.getElementById('text-type').style='display:none;'
        //       }else{
        //         this.shadowRoot.getElementById('initFile').style='display:block;'
        //       }
        //   });
        // }
      }

      test () {
        const menu = this.shadowRoot.getElementById('menu')
        menu.addEventListener('onmouseover', e => { 
            //获取被隐藏的菜单
            // var menu = this.shadowRoot.getElementById("menu");
            //获取菜单栏的坐标值
            var menux = menu.offsetLeft;
            var menuy = menu.offsetTop;
            var menuX = menu.offsetLeft+menu.offsetWidth;
            var menuY = menu.offsetTop+menu.offsetHeight;

            //获取鼠标的坐标值
            var event = window.event;
            var mouseX = event.clientX;
            var mouseY = event.clientY;

            if(mouseX<menux || mouseX>menuX || mouseY<menuY || mouseY>menuY){
                menu.style.display = "none";
            }
         })
        
      }

      backToHome(){
        document.getElementById('generate-img-ui').style='display: none;';
        document.getElementById('clip-front').style='display: block;';
        document.getElementById('generate-img-2-ui').style='display: none;';
        document.getElementById('prompt-template-ui').style='display: none;';
      }
      
      static get styles () {
          return css`
          body {
              margin: 2em 5em;
              font-family:Georgia, "Times New Roman", Times, serif;
          }
          h1, legend {
              font-family:Arial, Helvetica, sans-serif;
          }
          label, input, select {
              display:block;
          }
          input, select {
              margin-bottom: 1em;
          }
          fieldset {
              margin-bottom: 2em;
              padding: 1em;
          }
          fieldset fieldset {
              margin-top: 1em;
              margin-bottom: 1em;
          }
          input[type="checkbox"] {
              display:inline;
          }
          .range {
              margin-bottom:1em;
          }	
          .text-type input, .text-type label {
              display:inline-block;
          }
          .select{
            float: left;
            
          }
          
          
          textarea#yourText {
              width: 100%;
          }
          #resultText {
            
          }
          #register{
            margin: 2em 5em;
              font-family:Georgia, "Times New Roman", Times, serif;
          }

          #all {
            margin-left:5%;
            margin-right:2%;
            margin-top:9%;
      
          }
          
          
          
            .generateResult{
                width: 40px;
                height: 40px:
                cursor:pointer;

            }
            .bookmarkYourArt{
              width: 40px;
              height: 40px:
              cursor:pointer;

          }
          .backToHome{
            cursor:pointer;
          }
          `
        }
        // <input id="textType" name="textType" type="radio" value="3">
        // <label for="textType">inpainting</label> 
        // <input id="textType" name="textType" type="radio" value="4">
        // <label for="textType">img-to-action</label> 
      render () {
          return html`

          <div id="all">
            
              <form id="register">
              <h5>><a class="backToHome" @click=${() => { this.backToHome() }}>back</a></h5>
              <h3>Generate your art (Powered by stable diffusion) 
              &nbsp; 
              <a href="Stable-Diffusion-image-prompt-book.html" target="_blank" style="color:green;cursor:pointer;">Prompt book</a>
              &nbsp;&nbsp;
              <a href="https://dalle-photo.web.app/artpro.html" target="_blank"><img src="assets/brush.png" style="width:40px;"/></a>
              
              </h3>
              <fieldset>
                  <fieldset> 
                    <legend>type</legend> 
                    <div class="text-type"> 
                      <input id="textType1" name="textType" type="radio" value="1" checked="checked" @change=${() =>{this.clickRadio(this.shadowRoot.getElementById('textType1'))}}/>
                      <label for="textType">prompt to img</label> 
                      <input id="textType2" name="textType" type="radio" value="2" @change=${() =>{this.clickRadio(this.shadowRoot.getElementById('textType2'))}}/>
                      <label for="textType">img to img</label> 
                      &nbsp;&nbsp;
                      <label for="textType"><a href="https://dalle-photo.web.app/artpro.html" target="_blank">art pro</a><a href="https://dalle-photo.web.app/artpro.html" target="_blank"><img src="assets/brush.png" style="width:40px;"/></a></label> 
                      
                    </div> 
                  </fieldset>
                  <fieldset> 
                  <legend>input prompt, create your art:</legend> 
                  <div> 
                      <label>
                          <textarea id="yourText" name="yourText" rows="2" required="" .value=${this.yourText} @input=${e => { this.yourText = e.target.value }} placeholder="a cat smile"></textarea>
                      </label>
                  </div>
                  </fieldset>
                  <fieldset id="text-type"> 
                    <legend>upload picture</legend> 
                    <div class="text-type"> 
                      init img: &nbsp;&nbsp;
                      <input type="file" id="initFile" name="files[]" accept="image/png,image/jpeg,image/jpg" @change=${() =>{
                       
                          // const reader = new FileReader();
                          // reader.addEventListener('load',() => {
                          //     var uploaded_img = reader.result;
                          //     const image = new Image();
                          //     image.src = uploaded_img;
                          //    this.uploadFileSrc=image.src;
                          //    console.log(this.uploadFileSrc)
                            
                              
                          // });
                          // reader.readAsDataURL(this.shadowRoot.getElementById('initFile').files[0]);

                          this.uploadImage(this.shadowRoot.getElementById('initFile').files[0]);
                          
                        }}/>
                        
                    </div> 
                    
        
                  </fieldset>
                  <fieldset> 
                  <legend>other params</legend> 
                    <span id="yourSeedSpan">seed:</span>
                    <br/>
                    <input id="yourSeed" type="number" placeholder="1024~random" .value=${Math.floor(Math.random() * (455555 - 1024 + 1)) + 1024}/>
                    
                    <span id="yourNumOutPutSpan">output img num:</span>
                    <br/>
                    <input id="yourNumOutPut" type="number" size="4" maxlength="1" placeholder="1~4" value="1"/>
                  </fieldset> 
                  <fieldset> 
                  <legend>your art:</legend> 
                  <div> 
                      <label id="resultImgs">
                        
                      </label>
                  </div>
                  
                  </fieldset>
                  <div> 
                  <img src="assets/icons8-enter-key-100-2.png" id="generateResult" class="generateResult" @click=${() => { this.generateResult() }} />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <img src="assets/bookmark.png" class="bookmarkYourArt" @click=${() => { 
                    alert('temporarily unavailable') 
                  }} />
                  </div> 
              </fieldset>
              
          
              </form> 
          
              <grammarly-desktop-integration data-grammarly-shadow-root="true"></grammarly-desktop-integration>
          </div>
          
    
  
          `
      }
  }
  
